"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTestID = exports.setTestIDPrefix = void 0;
let testIdPrefix = '';
const setTestIDPrefix = (value) => {
    testIdPrefix = value;
};
exports.setTestIDPrefix = setTestIDPrefix;
const getTestID = (testID) => {
    if (!testID) {
        return testID;
    }
    if (testIdPrefix) {
        return `${testIdPrefix}${testID}`;
    }
    return testID;
};
exports.getTestID = getTestID;
